export const decodeJwt = token => {
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(char => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

export const storeDayPrograms = ({ token, user }) => {
  const decodedUser = decodeJwt(token);
  const dayPrograms = user?.day_programs || decodedUser?.userData?.day_programs;

  localStorage.setItem(
    'dayPrograms',
    JSON.stringify(Array.isArray(dayPrograms) ? dayPrograms : [])
  );
};

/**
 * Persist the SharedLiving caregiver's assigned patients from the
 * `/users/profile` response. The backend is the single source of truth — we do
 * NOT decode the JWT — so assignment changes are picked up without a re-login.
 */
export const storeAtHomePatients = ({ user }) => {
  const athomePatients =
    user?.athome_patients ||
    user?.athomePatients ||
    [];

  localStorage.setItem(
    'athomePatients',
    JSON.stringify(Array.isArray(athomePatients) ? athomePatients : [])
  );
};
